import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Banknote, CreditCard, ArrowRightLeft, Loader2, CheckCircle } from 'lucide-react';
import { formatCurrency } from '../../lib/utils';

export default function CheckoutModal({
  open,
  onOpenChange,
  total,
  discount,
  setDiscount,
  pointsToRedeem,
  setPointsToRedeem,
  paymentMethod,
  setPaymentMethod,
  selectedClient,
  onConfirm,
  loading,
}) {
  const finalTotal = total - discount - pointsToRedeem;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Procesar Pago</DialogTitle>
        </DialogHeader>
        <div className="space-y-6">
          <div className="text-center py-4 bg-slate-50 rounded-xl">
            <div className="text-sm text-slate-500">Total a Pagar</div>
            <div className="text-4xl font-bold text-blue-600 tabular-nums">
              {formatCurrency(finalTotal)}
            </div>
          </div>

          <div>
            <Label>Método de Pago</Label>
            <div className="grid grid-cols-3 gap-2 mt-2">
              <button
                type="button"
                className={`p-4 border-2 rounded-xl flex flex-col items-center gap-2 transition-all ${
                  paymentMethod === 'efectivo' ? 'border-blue-600 bg-blue-50' : 'border-slate-200'
                }`}
                onClick={() => setPaymentMethod('efectivo')}
                data-testid="payment-efectivo"
              >
                <Banknote className="w-6 h-6" />
                <span className="text-sm font-medium">Efectivo</span>
              </button>
              <button
                type="button"
                className={`p-4 border-2 rounded-xl flex flex-col items-center gap-2 transition-all ${
                  paymentMethod === 'tarjeta' ? 'border-blue-600 bg-blue-50' : 'border-slate-200'
                }`}
                onClick={() => setPaymentMethod('tarjeta')}
                data-testid="payment-tarjeta"
              >
                <CreditCard className="w-6 h-6" />
                <span className="text-sm font-medium">Tarjeta</span>
              </button>
              <button
                type="button"
                className={`p-4 border-2 rounded-xl flex flex-col items-center gap-2 transition-all ${
                  paymentMethod === 'transferencia' ? 'border-blue-600 bg-blue-50' : 'border-slate-200'
                }`}
                onClick={() => setPaymentMethod('transferencia')}
                data-testid="payment-transferencia"
              >
                <ArrowRightLeft className="w-6 h-6" />
                <span className="text-sm font-medium">Transfer</span>
              </button>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div>
              <Label htmlFor="discount">Descuento</Label>
              <Input
                id="discount"
                type="number"
                min="0"
                value={discount}
                onChange={(e) => setDiscount(e.target.value)}
                className="mt-1"
                data-testid="checkout-discount"
              />
            </div>
            <div>
              <Label htmlFor="points">Usar Puntos</Label>
              <Input
                id="points"
                type="number"
                min="0"
                max={selectedClient?.points || 0}
                value={pointsToRedeem}
                onChange={(e) => setPointsToRedeem(e.target.value)}
                className="mt-1"
                data-testid="checkout-points"
              />
              <div className="text-xs text-slate-500 mt-1">
                Disponibles: {selectedClient?.points || 0}
              </div>
            </div>
          </div>

          <Button
            className="pos-btn-success"
            onClick={onConfirm}
            disabled={loading}
            data-testid="confirm-payment-btn"
          >
            {loading ? (
              <Loader2 className="w-5 h-5 animate-spin" />
            ) : (
              <>
                <CheckCircle className="w-5 h-5" />
                Confirmar Pago
              </>
            )}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
